import { RouteName } from "constant/routeNames";
import { decodeHtmlEntities } from "constant/htmlEntities";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PayperviewLazyLoading from "./PayperviewLazyLoading";
import AddToFavPayperview from "./AddToFavPayperview";
import { useSelector } from "react-redux";
import ExpiredStatus from "./ExpiredStatus";
import PayperviewService from "services/payperview/PayperviewServie";
import LiveButton from "./LiveButton";
import { Tooltip as ReactTooltip } from "react-tooltip";

const PayPerViewCard = ({ event, isPurchased, user }: any) => {
  const [hasPurchasedMovie, setHasPurchasedMovie] = useState<boolean>(false);
  const [remainingDays, setRemainingDays] = useState();

  useEffect(() => {
    if (isPurchased) {
      if (event && event?.rentable) {
        hasEventPurchasedMovie(event?.id);
      }
    }
  }, [isPurchased]);

  const hasEventPurchasedMovie = async (event_id: any) => {
    const response = await PayperviewService.hasPurchasedMovie(event_id);
    setHasPurchasedMovie(response?.isRentalValid);
    setRemainingDays(response?.remaining_days);
  };

  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  const rawEventDate =
    event?.start_date_time || event?.event_formatted_date || event?.date_time;
  const parsedEventDate = rawEventDate ? new Date(rawEventDate) : null;
  const formattedEventDate =
    parsedEventDate && !isNaN(parsedEventDate.getTime())
      ? new Intl.DateTimeFormat(undefined, {
          weekday: "long",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          timeZoneName: "short",
        }).format(parsedEventDate)
      : "";

  return (
    <Link
      to={RouteName.PayperviewDetailsRoute.replace(":slug", event?.slug)}
      className="group mt-3 block w-full cursor-pointer overflow-hidden rounded-xl text-white"
    >
      {/* banner — 16:9 */}
      <div className="relative aspect-video w-full overflow-hidden">
        <PayperviewLazyLoading
          imgSrc={
            event?.banner ||
            event?.banner_url ||
            event?.thumbnail ||
            event?.thumbnail_url
          }
          imgAlt={"ppv"}
          imgHeight={"100%"}
          imgWidth={"100%"}
          classname="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />

        {/* bottom scrim for badge legibility over the banner */}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 to-transparent" />

        {isPurchased || event?.isBuy === 0 ? (
          <>
            {event.category === "Movie" ? (
              <ExpiredStatus days={remainingDays} />
            ) : (
              <>{event?.event_status === "streaming" && <LiveButton />}</>
            )}
          </>
        ) : (
          <></>
        )}

        {/* badges overlay — outside the scale/zoom so nothing gets clipped or distorted */}
        <div className="pointer-events-none absolute inset-0 z-10">
          {loggedInUser && user?.id === loggedInUser?.id && (
            <div className="pointer-events-auto absolute right-2.5 top-2.5">
              <AddToFavPayperview PayperviewCard={true} payperview={event} />
            </div>
          )}
          {isPurchased ? (
            <div className="absolute bottom-2.5 left-2.5 flex items-center gap-1.5 rounded-md bg-[#f30543] px-2.5 py-[4px]">
              <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <p className="text-[12px] font-semibold text-white">
                Purchased
              </p>
            </div>
          ) : (
            <span />
          )}
        </div>
      </div>

      {/* content */}
      <div className="px-5 pb-4 pt-[14px]">
        <p
          className="line-clamp-2 text-[17px] font-semibold leading-tight tracking-[-0.01em] text-[#f3f5f7] transition-colors group-hover:text-white"
          
        >
          {decodeHtmlEntities(event?.title)}
        </p>
        <div className="z-50 text-sm">
          <ReactTooltip
            id={`ppv-title-${event?.title}`}
            place="top"
            content={event?.title}
            style={{ width: "180px" }}
          />
        </div>

        {(formattedEventDate || event?.category) && (
          <div className="mt-2 flex items-center justify-between gap-2">
            {formattedEventDate ? (
              <p className="min-w-0 truncate text-[12.5px] font-normal leading-tight text-[#8494a6]">
                {formattedEventDate}
              </p>
            ) : (
              <span />
            )}
            {event?.category ? (
              <span className="shrink-0 whitespace-nowrap rounded-full border border-[#f30543]/25 bg-[#f30543]/10 px-2.5 py-[3px] text-[11px] font-semibold leading-tight text-[#f30543]">
                {event?.category}
              </span>
            ) : (
              <span />
            )}
          </div>
        )}

        {isPurchased && remainingDays != null && (
          <p className="mt-[7px] text-[11px] leading-tight text-[#5b6a80]">
            Available for {remainingDays} more day
            {Number(remainingDays) === 1 ? "" : "s"}
          </p>
        )}
      </div>
    </Link>
  );
};

export default PayPerViewCard;
